<template>
	<div>
		<img :src="originalImageUrl" style="width:100%;" alt="" />
	</div>
</template>

<script>
	import { modelRequest } from '@/network/requests/model'
	import { modelSideRequest } from '@/network/requests/modelSide'
	import { modelSideImageRequest, getModelSideImageUrlByFileId } from '@/network/requests/modelSideImage'
	export default {
		props: {
			/**
			 * 批次Id。
			 */
			id: {
				type: String,
			},
		},
		data() {
			return {
				originalImageUrl: '',
			}
		},
		methods: {
			async getProductImage() {
				//获取批次所有模板，只取第一个。
				var model = (await modelRequest.queryAll({ roll_id: this.id }))[0]
				if (model) {
					//检测面。
					var modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid }, undefined, { side_index: 1 })
					//检测面图片。
					var modelSideImages = await modelSideImageRequest.queryAll({ model_id: model._id.$oid })

					var side_index = modelSides[0].side_index

					var md = modelSides.find(t => t.side_index == side_index)
					if (!md) {
						return
					}

					var msi = modelSideImages.find(t => t.model_side_id == md._id.$oid)
					if (msi) {
						//获取版图的 restHeart 的url。
						var imgBase64 = await getModelSideImageUrlByFileId(msi.file_id)
						//对 hostmain 进行修改，已方便通过代理的方式访问图片。
						this.originalImageUrl = imgBase64 // window.location.protocol + '//' + window.location.host + url
					}
				} else {
					this.$message.error('没有该批次对应的版图信息,因此无法加载数据')
				}
			},
		},
		async created() {
			await this.getProductImage()
		},
	}
</script>

<style></style>
